<template>
  <div class="app-footer">
    <div class="text">版权所有：研工部/研究生院</div>
    <div class="text">联系邮箱：nuaa_class101@163.com</div>
    <div class="imgCode">
      <img src="@/assets/images/code.jpg">
      <div>站点支持与反馈qq群:865458745或530562090</div>
    </div>
    
    <img class="imgCode2" src="@/assets/images/code.jpg">
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.app-footer {
  height: 200px;
  width: 100%;
  background: url("~@/assets/images/footer.jpg") no-repeat center;
  color: white;
  text-align: center;
  position: relative;
  .text:nth-child(1) {
    padding-top: 60px;
  }
  .text {
    line-height: 40px;
  }
  .imgCode2 {
    position: absolute;
    right: calc(50% - 550px);
    height: 300px;
    bottom: 20px;
    display: none;
  }

  .imgCode {
    display: block;
    position: absolute;
    right: calc(50% - 300px);
    height: 150px;
    top: 20px;
    cursor: pointer;
    div{
      font-size: 12px;
    }
    img{
      width: 96px;
      height: 100%;
    }
  }
}

.imgCode:hover + .imgCode2 {
  display: block;
}
</style>